import { getListDataFunctionFactory } from '../../modules/getListDataFunctionFactory'
import type { TEntityId } from '~/types/models'
import type { IOpportunityMSTeamMember } from '@/types/opportunity/models'
import { getTeamMemberDataById } from '~/api/msw/api/teamMembers/mockData'

const opportunityMSTeamMemberListData =
  undefined as unknown as IOpportunityMSTeamMember[]

export const getOpportunityMSTeamMemberListData = getListDataFunctionFactory<
  IOpportunityMSTeamMember[]
>({
  listData: opportunityMSTeamMemberListData,
  storageKey: 'opportunitymsteammembers',
  getStartingListData: getStartingOpportunityMSTeamMemberListData,
})

export async function getOpportunityMSTeamMemberListDataByOMSId(id: TEntityId) {
  const listData = await getOpportunityMSTeamMemberListData()
  return listData.filter(
    (omstm: IOpportunityMSTeamMember) =>
      omstm.opportunityMasterService.id === id
  )
}

export async function getOpportunityMSTeamMemberDataById(
  id: TEntityId
): Promise<IOpportunityMSTeamMember | undefined> {
  const listData = await getOpportunityMSTeamMemberListData()
  return listData.find((otm: IOpportunityMSTeamMember) => otm.id === id)
}

export async function getStartingOpportunityMSTeamMemberListData(): Promise<
  IOpportunityMSTeamMember[]
> {
  return [
    {
      id: 'XXOMSTM0006',
      hrid: 'OMSTM0006',
      opportunityMasterService: {
        id: 'XXOMS0005',
        label: 'DIA - Boston, Lake & Waltham',
      },
      teamMember: await getTeamMemberDataById('XXTM0006')!,
      splitFraction: 0.1,
      status: {
        id: 2,
        label: 'Active',
      },
      version: '1',
      canBeDeleted: true,
    },
  ]
}
